// extracted by mini-css-extract-plugin
export default {"summaryBox":"SummaryBox_summaryBox__3NGBf","title":"SummaryBox_title__U7OPo","item":"SummaryBox_item__OGGYd","total":"SummaryBox_total__pE0aQ"};